import React from "react";
import { TouchableOpacity, View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import ChevronRight from "@assets/svg/ChevronRight";
import t from "@constants/localization";
import TicketCard from "../SupportTickets/TicketCard";
import navigateToListOrItem from "../utils/navigateToListOrItem";

const PATH = "screens/SupportTree/SupportList/RecentTickets";

const RecentTickets = (props) => {
  const {
    children = [],
    handleReloadList = () => {},
    onCancelTicket = () => {},
    fetching = false,
  } = props;
  return (
    <View>
      <View style={styles.mainView}>
        <Text variant="subtitle_16" style={styles.yourAllTickets}>
          {t(`${PATH}/yourAllTickets`)}
        </Text>
        <TouchableOpacity onPress={() => navigateToListOrItem(props)}>
          <View style={styles.viewAllView}>
            <Text
              variant="body_text_2"
              style={{ color: "#E40046", marginRight: 5 }}
            >
              {t(`${PATH}/viewAll`)}
            </Text>
            <ChevronRight pathFill="#E40046" width={8} height={20} />
          </View>
        </TouchableOpacity>
      </View>
      <TicketCard
        fetching={fetching}
        ticket={children[0]}
        handleReloadList={handleReloadList}
        onCancelTicket={() =>
          onCancelTicket(
            props.children[0].ticket_id,
            props.children[0].cf_issue_level_1,
          )
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  yourAllTickets: {
    flex: 1,
    marginTop: 16,
    marginBottom: 10,
  },
  mainView: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 15,
  },
  viewAllView: {
    flexDirection: "row",
    padding: 7,
    paddingRight: 0,
  },
});

export default RecentTickets;
